export function formatKeywords(keywords: string | string[]) {
    if (keywords) {
        return `With keyword(s) "${keywords}"`;
    }

    return '';
}
